<template>
  <div>
    <b-tabs active-nav-item-class="font-weight-bold text-light bg-info">
      <div v-for="(itemT, indT) in tekshiruvlar" :key="indT">
        <b-tab
          v-if="!itemT.deleted || (localUser.role == 'Hamshira' && itemT.ins_setting == 'reagent' && !itemT.deleted)"
          :title="itemT.inspection.name"
          :class="{ kasallikT: $route.name == 'ArxivOne' }"
          title-link-class="mr-2 mt-1 text-light font-weight-bold bg-success"
          style="padding: 0px !important;"
        >
          
          <div class="tek-card" style="position: relative;">
            <!-- <div class="ins-count">
              {{ itemT.count }}
            </div> -->
            <div>
              <div
                class="tek-name-d"
                :class="{
                  vazvrat: itemT.backlog,
                  colorBacklog: !itemT.backlog
                }"
              >
                <div style="display: flex; justify-content: space-between;">
                  <div
                    style="margin-left: 10px; display: flex; justify-content: space-between;"
                  >
                    <div v-if="!itemT.shablon">
                      <b-form-checkbox
                        @change="PechatTek(itemT)"
                        :value="true"
                        :unchecked-value="false"
                      >
                      </b-form-checkbox>
                    </div>
                    <div v-if="!$store.state.kasTar">
                      <b-button
                        v-if="itemT.shablon"
                        :disabled="
                          !(
                            localUser.id == itemT.user_id ||
                            localUser.role == 'Admin'
                          )
                        "
                        :class="{ kasallikT: $store.state.kasTar }"
                        class="navbarBtnTashxis"
                        style="margin-right: 10px;"
                        v-b-modal="
                          'modal-shablon' + indT + 'reg_inspec' + modalIdCom
                        "
                        @click="getShablon"
                        variant="primary"
                      >
                        <b-icon icon="collection"></b-icon>
                      </b-button>
                      <b-modal
                        :id="'modal-shablon' + indT + 'reg_inspec' + modalIdCom"
                        size="lg"
                        :title="$t('Шаблонлар рўйхати')"
                        hide-footer
                      >
                        <Shablon
                          :indRegShif="indT"
                          :shabType="'reg_inspec'"
                          :modalIdCom="modalIdCom"
                          :itemsShablon="itemsShablon"
                          @ShablonGet="getShablon"
                          @RowClickedShab="RowClickedShab"
                        />
                      </b-modal>
                    </div>

                    <b-button
                      variant="primary"
                      @click="allPechat(itemT)"
                      class="navbarBtnTashxis"
                      style="margin-right: 10px;"
                    >
                      <b-icon icon="printer-fill"></b-icon>
                      Печать
                    </b-button>
                  </div>
                  <div>
                    <b-button
                      v-if="
                        (itemT.shablon && localUser.id == itemT.user_id) ||
                          localUser.role == 'Admin'
                      "
                      :disabled="!itemT.shablon"
                      style="margin-right: 10px;"
                      variant="primary"
                      @click="clicknewShablon(indT)"
                      v-b-modal="
                        'modal-new-shab-creat-ins-' + indT + modalIdCom
                      "
                      class="navbarBtnTashxis"
                    >
                      <b-icon icon="arrow-up-circle-fill"></b-icon>
                    </b-button>
                    <b-modal
                      :id="'modal-new-shab-creat-ins-' + indT + modalIdCom"
                      :title="$t('Шифокор шаблон')"
                      hide-footer
                    >
                      <div>
                        <div>
                          <b-input
                            type="text"
                            v-model="newShablon.name"
                          ></b-input>
                        </div>
                        <div>
                          <span class="shirift">
                            {{ "Жадвал" }}
                          </span>
                          <b-form-checkbox
                            style="display: flex; width: 100px;"
                            v-model="newShablon.table_type"
                            :value="true"
                            :unchecked-value="false"
                          >
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div class="CreateName">
                        <b-button
                          class="modalBtn1"
                          size="sm"
                          style="height: 37px;"
                          variant="danger "
                          @click="ShifokorShablonClose(indT)"
                        >
                          <b-icon icon="calendar2-x"></b-icon>
                          {{ $t("Бекор қилиш") }}
                        </b-button>
                        <b-button
                          class="mt-3 ml-2 modalBtn"
                          @click="ShifokorShablon(indT)"
                          variant="success"
                        >
                          <b-icon icon="calendar2-plus"></b-icon>
                          {{ $t("Сақлаш") }}
                        </b-button>
                      </div>
                    </b-modal>
                    <b-button
                      v-if="
                        localUser.id == itemT.user_id ||
                          localUser.role == 'Admin'
                      "
                      style="margin-right: 10px;"
                      variant="primary"
                      class="navbarBtnTashxis"
                      @click="$refs[`insfiles${indT}`][0].click()"
                    >
                      <b-icon icon="cloud-arrow-down-fill"></b-icon>
                    </b-button>

                    <input
                      type="file"
                      style="display: none"
                      :id="`insfiles${indT}`"
                      :ref="`insfiles${indT}`"
                      @change="onUploadTashxis(itemT, indT)"
                      name="href"
                      class="my-0"
                    />
                  </div>
                  <div>
                    <v-select
                      class="Tekshiruvchi-index-user mr-2"
                      :disabled="
                        localUser.role != 'Admin' &&
                          localUser.role != 'Registrator' &&
                          itemT.status == 'complate'
                      "
                      @input="changeIns($event, indT)"
                      label="user_name"
                      :options="Tekshiruvchi"
                      :reduce="option => option.id"
                      v-model="itemT.user_id"
                    />
                  </div>
                  <div>
                    <input
                      type="datetime-local"
                      class="input-datetime-local"
                      v-model="itemT.date_doctor"
                    />
                  </div>
                  <v-select
                    :filter="fuseSearch"
                    v-if="
                      localUser.role == 'Admin' ||
                        localUser.role == 'Registrator' ||
                        localUser.role == 'Kasser'
                    "
                    class="Tekshiruvchi-index-user ml-2"
                    id="naprovitel"
                    :options="Naprovitel"
                    @input="changeIns($event, indT)"
                    :get-option-label="option => option.name"
                    :reduce="option => option.id"
                    v-model="itemT.direct_id"
                  >
                    <template #option="{ name, direct_id }">
                      {{ name }}
                      <br />
                      <b>{{ direct_id }}</b>
                    </template>
                  </v-select>
                  <!-- <div style="margin-left: 10px;">
                    {{ itemT.date_time }}
                    <date-picker
                      style="width: 100%;"
                      id="tugkun"
                      v-model="itemT.date_time"
                      format="DD MM YYYY HH:mm:ss"
                      value-type="X"
                      type="date"
                      :lang="lang"
                    ></date-picker>
                  </div> -->
                  <b-button
                    v-if="!$store.state.kasTar && !itemT.shablon"
                    class="navbarBtnTashxis"
                    style="margin-left: 10px;"
                    @click="Arrow(itemT)"
                    variant="primary"
                  >
                    <b-icon icon="arrow90deg-right"></b-icon>
                  </b-button>
                  <b-button
                    v-if="!itemT.backlog"
                    :class="{ kasallikT: $store.state.kasTar}"
                    :disabled="send"
                    class="navbarBtnTashxis"
                    style="margin-left: 10px;"
                    @click="uploadData(itemT)"
                    variant="primary"
                  >
                    <b-icon icon="upload"></b-icon>
                  </b-button>
                </div>
                <div style="display: flex;">
                  <input 
                    style="width: 50px; margin-right: 10px;" 
                    class="shif-price" 
                    @input="changeCount(itemT, indT)"
                    v-if="!itemT.pay_summa && Number(itemT.date_time) > dateDeleted && itemT.ins_setting == 'reagent'" 
                    type="number" 
                    min="0"
                    v-model="itemT.count"
                  >
                  <div style="width: 50px; margin-right: 10px;" class="shif-price" v-else-if="itemT.ins_setting == 'reagent'">
                    {{itemT.count}}
                  </div>
                  <div
                    class="shif-price"
                    v-if="
                      localUser.role != 'Loborant' &&
                        localUser.role != 'Uzi ' &&
                        localUser.role != 'Shifokor'
                    "
                  >
                    <div style="width: 180px;">
                      {{ itemT.price | numFormat }}
                    </div>
                    <button
                      v-if="
                        (localUser.role == 'Admin' ||
                          localUser.role == 'Kasser' || localUser.role == 'Registrator' || localUser.role == 'Katta hamshira' || localUser.role == 'Hamshira') &&
                          !itemT.pay_summa
                      "
                      class="navbarBtnTashxis-summa navbarBtnTashxis"
                      v-b-modal="'modal-summa-change-tek' + indT + modalIdCom"
                      @click="price = itemT.price"
                    >
                      <b-icon style="width: 15px;" icon="pencil-fill"></b-icon>
                    </button>
                    <b-modal
                      :id="'modal-summa-change-tek' + indT + modalIdCom"
                      :title="itemT.name"
                      hide-footer
                    >
                      <div style="width: 100%;">
                        <vue-numeric
                          class="numberic-pay"
                          separator="space"
                          :precision="2"
                          v-model="price"
                        ></vue-numeric>
                      </div>
                      <div class="CreateName">
                        <b-button
                          class="modalBtn1"
                          size="sm"
                          style="height: 37px;"
                          variant="danger "
                          @click="close(indT)"
                        >
                          <b-icon icon="calendar2-x"></b-icon>
                          {{ $t("Бекор қилиш") }}
                        </b-button>
                        <b-button
                          class="mt-3 ml-2 modalBtn"
                          @click="Change(itemT, indT)"
                          variant="success"
                        >
                          <b-icon icon="calendar2-plus"></b-icon>
                          {{ $t("Сақлаш") }}
                        </b-button>
                      </div>
                    </b-modal>
                  </div>
                  <!-- <b-form-checkbox
                    style="display: flex; width: 100px;"
                    v-if="
                      localUser.role == 'Kasser' ||
                        localUser.role == 'Admin' ||
                        localUser.role == 'Registrator'
                    "
                    :class="{ kasallikT: $store.state.kasTar }"
                    v-model="itemT.vazvrat"
                    @change="Vazvrat(itemT, indT)"
                    :value="true"
                    :unchecked-value="false"
                  >
                    Возврат
                  </b-form-checkbox> -->
                  <b-button
                    style="width: 30px; height: 30px; display: flex; justify-content: center;"
                    v-if="
                      !itemT.pay_summa &&
                        !itemT.vazvrat &&
                        (localUser.role == 'Admin' ||
                          localUser.role == 'Kasser' ||
                          localUser.role == 'Registrator' ||
                          Number(itemT.date_time) > dateDeleted)
                    "
                    :class="{ kasallikT: $store.state.kasTar }"
                    @click="deleteTek(indT, itemT)"
                    variant="outline-danger"
                  >
                    <b-icon style="width: 17px;" icon="trash"></b-icon>
                  </b-button>
                </div>
              </div>

              <div v-if="!itemT.shablon">
                <table class="table table-sm table-bordered">
                  <thead id="head">
                    <tr>
                      <th style="width: 40px;">№</th>
                      <!-- <th>Печать</th> -->
                      <th>Тип анализа</th>
                      <th>Результат</th>
                      <th>Норма</th>
                      <th
                        v-if="
                          itemT.type &&
                            localUser.role != 'Shifokor' &&
                            localUser.role != 'Loborant'
                        "
                      >
                        Сумма
                      </th>
                      <!-- <th>Возврат</th> -->
                      <th v-if="itemT.type" style="width: 40px;"></th>
                    </tr>
                  </thead>
                  <tbody class="BayonotThead">
                    <tr
                      v-for="(item,
                      index) in itemT.registration_inspection_child"
                      :key="index"
                      :class="{
                        vazvrat: item.vazvrat == true || itemT.vazvrat == true
                      }"
                    >
                      <td v-if="!item.deleted" style="width: 40px;">
                        {{ index + 1 }}
                      </td>
                      <!-- <td>
                        <b-form-checkbox
                          @change="pechat(itemT, item)"
                          :value="true"
                          :unchecked-value="false"
                        >
                        </b-form-checkbox>
                      </td> -->
                      <td
                        v-if="item.name == item.norm && !item.deleted"
                        colspan="3"
                        style="text-align: center; font-weight: 700; border: none !important;"
                      >
                        {{ item.name }}
                      </td>
                      <td
                        v-if="item.name != item.norm && !item.deleted"
                        style="text-align: start; padding-left: 5px !important;"
                      >
                        {{ item.name }}
                      </td>
                      <td
                        v-if="item.name != item.norm && !item.deleted"
                        class="c-editor-edit"
                        style="width: 200px;"
                        :class="{ kasallikT: $store.state.kasTar }"
                      >
                        <input
                          v-if="
                            item.vazvrat != true &&
                              itemT.vazvrat != true &&
                              (localUser.role == 'Loborant' ||
                                localUser.role == 'Admin')
                          "
                          style="height: 35px; border: 1px solid #ccc; border-radius: 7px;"
                          type="text"
                          v-model="item.text"
                          :id="'textarea-norm-rez' + indT + '_' + index"
                          :ref="'textareaRef' + indT + '_' + index"
                          @input="uziComplate(itemT, indT)"
                          :disabled="
                            !(
                              localUser.id == itemT.user_id ||
                              localUser.role == 'Admin'
                            )
                          "
                          @keydown="keyUp($event, index, indT)"
                        />
                        <div v-else class="multiline-text">
                          {{ item.text }}
                        </div>
                      </td>
                      <td
                        v-if="item.name != item.norm && !item.deleted"
                        class="c-editor-edit"
                        style="width: 400px;"
                        :class="{ kasallikT: $store.state.kasTar }"
                      >
                        <div class="multiline-text">{{ item.norm }}</div>
                      </td>
                      <td
                        v-if="
                          itemT.type &&
                            localUser.role != 'Shifokor' &&
                            localUser.role != 'Loborant' &&
                            !item.deleted
                        "
                        style="width: 150px;"
                      >
                        {{ item.price | numFormat }}
                      </td>
                      <!-- <td v-if="!item.deleted">
                        <div v-if="itemT.type">
                          <b-form-checkbox
                            style="display: flex; width: 200px;"
                            v-if="
                              localUser.role == 'Kasser' ||
                                localUser.role == 'Admin' ||
                                localUser.role == 'Registrator'
                            "
                            :class="{ kasallikT: $store.state.kasTar }"
                            v-model="item.vazvrat"
                            @change="Vazvrat(item, indT, index)"
                            :value="true"
                            :unchecked-value="false"
                          >
                            Возврат
                          </b-form-checkbox>
                        </div>
                      </td> -->
                      <td
                        v-if="itemT.type && !item.deleted"
                        :class="{ kasallikT: $store.state.kasTar }"
                      >
                        <b-button
                          style="width: 30px; height: 30px; display: flex; justify-content: center;"
                          v-if="
                            !itemT.pay_summa &&
                              !itemT.vazvrat &&
                              !item.vazvrat &&
                              (localUser.role == 'Admin' ||
                                localUser.role == 'Kasser' ||
                                localUser.role == 'Registrator' ||
                                Number(itemT.date_time) > dateDeleted)
                          "
                          @click="deleteTekChil(indT, index, item)"
                          variant="outline-danger"
                        >
                          <b-icon style="width: 17px;" icon="trash"></b-icon>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else>
                <div
                  v-for="(item, index) in itemT.registration_inspection_child"
                  :key="index"
                  style="display: flex; text-align: center; width: 100%;"
                  :class="{
                    vazvrat: item.vazvrat == true || itemT.vazvrat == true
                  }"
                >
                  <div v-if="itemT.reg_ins_file.length" style="margin: 3px;">
                    <div v-for="(item, index) in itemT.reg_ins_file">
                      <!-- <b-button
                            style="margin-right: 10px;"
                            variant="primary"
                            class="navbarBtnTashxis"
                            @click="downloadFile(item.file_name)"
                          >
                            Юклаб олиш
                          </b-button> -->
                      <div
                        style="margin-bottom: 10px; display: flex; justify-content: center;"
                      >
                        <img
                          v-b-modal="
                            'modal-img-show' + indT + index + modalIdCom
                          "
                          :src="BASE_URL + item.file_name"
                          style="width: 150px;"
                        />
                        <b-button
                          style="margin-left: 10px; width: 30px; height: 30px; display: flex; justify-content: center;"
                          v-if="
                            localUser.role == 'Admin' ||
                              localUser.role == 'Loborant' ||
                              localUser.role == 'Registrator'
                          "
                          @click="delete_reg_file(indT, index, item)"
                          variant="outline-danger"
                        >
                          <b-icon style="width: 17px;" icon="trash"></b-icon>
                        </b-button>
                      </div>
                      <b-modal
                        :id="'modal-img-show' + indT + index + modalIdCom"
                        size="xl"
                        hide-footer
                      >
                        <img :src="BASE_URL + item.file_name" />
                      </b-modal>
                    </div>
                  </div>

                  <div
                    style="width: calc(100% - 300px); border: 1px solid #ccc"
                  >
                    <VueEditorText
                      :text="item.norm"
                      :id="itemT.inspection_id"
                      :status="'inspection'"
                      :indReg="indT"
                      :name="{
                        name: itemT.inspection.name,
                        category: itemT.category.name
                      }"
                      :table_type="itemT.table_type"
                      :uppercase="itemT.uppercase"
                      :disabled="
                        (localUser.id == itemT.user_id ||
                          localUser.role == 'Admin' ||
                          itemT.status != 'complate') &&
                        !$store.state.kasTar
                          ? false
                          : true
                      "
                      :indexChild="index"
                      :defaultHeigth="defaultHeigth"
                      @vueEditorText="vueEditorText"
                      @textChangeValueIndex="textChangeValueIndex"
                    />
                  </div>
                  <!-- <div v-else>
                    <UziExo
                      :statsionar_text="item.norm"
                      :modalIdCom="modalIdCom"
                      :index="indT"
                      @statsionar_text_change="statsionar_text_change"
                    />
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </div>
    </b-tabs>
  </div>
</template>
<script>
// import UziExo from "./UziExo.vue";
import moment from "moment";
import Shablon from "../Shifokor/Shablon.vue";
import VueEditorText from "../VueEditorText.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  inject: ["BASE_URL"],
  props: [
    "tekshiruvlar",
    "backlog",
    "created_at",
    "modalIdCom",
    "PechatTekshiruv",
    "Naprovitel",
    "dateDeleted",
    "Tekshiruvchi"
  ],
  components: {
    Shablon,
    VueEditorText,
    // UziExo
  },
  data() {
    return {
      newShablon: {
        doctor_id: JSON.parse(localStorage.getItem("user")).id,
        name: "",
        text: "",
        doc_type: "reg_inspec"
      },
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
      },
      localUser: JSON.parse(localStorage.getItem("user")),
      pechatTek: [],
      itemsShablon: [],
      price: 0,
      defaultHeigth: "height: 900px;",
      textChangeValue: {
        index: null,
        key: null
      },
      activeUser: null
    };
  },
  methods: {
    uploadData(item){
      let self = this;
      self.send = true
      let t = {
        bemorId: this.$store.state.bemor.id,
        name: this.$store.state.bemor.fullname,
        gender: this.$store.state.bemor.gender,
        birthday: moment.unix(this.$store.state.bemor.birthday).format("DD.MM.YYYY"),
        create_at: moment.unix(this.created_at).format("DD.MM.YYYY HH:mm"),
        bolim: item.shablon ? item.category.name : 'Лаборатория',
        otdel: item.inspection.User.user_name == 'Рахмонкулова Севара' ? 'Лаборант' : 'Врач:',
        doctor_name: item.inspection.User.user_name,
        inspection: [item]
      };
      axios({
        method: "post",
        url: "/registration/upload_pdf",
        data: t
      }).then(res => {
        self.$bvToast.toast(`${self.$t("Малумотлар қўшилди")}`, {
            title: self.$t("Огоҳлантириш"),
            autoHideDelay: 2000,
            appendToast: true,
            variant: "success"
          });
        self.send = false
      })
    },
    onUploadTashxis(item, index) {
      let self = this;
      const formData = new FormData();
      formData.append("href", self.$refs[`insfiles${index}`][0].files[0]);
      formData.append("reg_id", item.registration_id);
      formData.append("parent_id", item.inspection_id);
      axios
        .post("/registration/file", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          // self.tashxisfile = res.data;
          // let reg_id = self.$route.params.id
          // if (self.$route.path != "/user-create") {
          //     reg_id = self.$route.params.id;
          // }
          self.tekshiruvlar[index].reg_ins_file.push({
            file_name: res.data.data.href,
            reg_id: item.registration_id,
            parent_id: item.inspection_id
          });
          self.tekshiruvlar[index].update = true;
        });
    },
    statsionar_text_change(data, doc_type, index) {
      this.tekshiruvlar[index].registration_inspection_child[0].norm = data;
      this.tekshiruvlar[index].update = true;
    },
    delete_reg_file(indT, index, item) {
      let self = this;
      let data = {
        file_name: item.file_name,
        id: item.id
      };
      axios({
        method: "post",
        url: "/registration/file_delete",
        data: data
      }).then(res => {
        if (res) {
          self.tekshiruvlar[indT].reg_ins_file.splice(index, 1);
          self.tekshiruvlar[indT].update = true;
        }
      });
    },
    downloadFile(url) {
      let fullPath = this.BASE_URL + url;
      // window.location.href = fullPath

      // let fullPath = this.BASE_URL + 'download/' + url;
      // console.log(fullPath);

      // // Create a temporary <a> element to trigger the download
      // const link = document.createElement('a');
      // link.href = fullPath;

      // // Trigger the download without setting 'download' attribute, backend will handle it
      // link.click();
    },
    deleteTek(ind, item) {
      this.$emit("delTek", item.price, false);
      // this.tekshiruvlar[ind].deleted = true;
      this.tekshiruvlar.splice(ind, 1);
      this.tekshiruvlar.push(item);
      for (const el of this.tekshiruvlar) {
        if (el.key == item.key) {
          el.deleted = true;
        }
      }
    },
    ShifokorShablonClose(index) {
      this.newShablon = {
        doctor_id: JSON.parse(localStorage.getItem("user")).id,
        name: "",
        text: "",
        doc_type: "reg_inspec"
      };
      this.$bvModal.hide(
        `${"modal-new-shab-creat-ins" + index + this.modalIdCom}`
      );
    },
    ShifokorShablon(index) {
      let self = this;
      axios({
        method: "post",
        url: "/shablon_doctor/create",
        data: self.newShablon
      }).then(res => {
        if (res) {
          self.newShablon = {
            name: "",
            text: "",
            doctor_id: JSON.parse(localStorage.getItem("user")).id,
            doc_type: "reg_inspec"
          };
          self.$bvModal.hide(
            `${"modal-new-shab-creat-ins-" + index + self.modalIdCom}`
          );
        }
      });
    },
    clicknewShablon(index) {
      this.newShablon.text = this.tekshiruvlar[
        index
      ].registration_inspection_child[0].norm.toString();
      this.newShablon.table_type = this.tekshiruvlar[index].table_type;
    },
    changeIns($event, indT) {
      this.tekshiruvlar[indT].update = true;
    },
    deleteTekChil(indT, index, item) {
      this.$emit("delTek", item.price, false);
      this.tekshiruvlar[indT].price -= item.price;
      this.tekshiruvlar[indT].backlog -= item.price;
      this.tekshiruvlar[indT].update = true;
      this.tekshiruvlar[indT].registration_inspection_child[
        index
      ].deleted = true;
      // if (this.tekshiruvlar[indT].registration_inspection_child.length == 1) {
      //   this.tekshiruvlar.splice(indT, 1);
      // } else {
      //   this.tekshiruvlar[indT].registration_inspection_child.splice(index, 1);
      // }
    },
    keyUp($event, index, indP, item) {
      if ($event.code == "NumpadEnter" || $event.code == "ArrowDown") {
        // const textarea = 'textareaRef' + (index+1);
        const textareaElement = document.getElementById(
          `${"textarea-norm-rez" + indP + "_" + (index + 1)}`
        );
        if (textareaElement) {
          textareaElement.focus();
          textareaElement.setSelectionRange(0, 0);
        }
        $event.preventDefault();
      } else if ($event.code == "ArrowUp") {
        const textareaElement = document.getElementById(
          `${"textarea-norm-rez" + indP + "_" + (index - 1)}`
        );
        if (textareaElement) {
          textareaElement.focus();
          textareaElement.setSelectionRange(0, 0);
        }
        $event.preventDefault();
      }
    },
    fuseSearch() {},
    vueEditorText(val, index, indexChild, textValue, type) {
      this.tekshiruvlar[index].registration_inspection_child[
        indexChild
      ].norm = val;
      if (
        this.localUser.role == "Loborant" &&
        this.tekshiruvlar[index].status == "waiting"
      ) {
        this.tekshiruvlar[index].user_id = this.localUser.id;
        this.tekshiruvlar[
          index
        ].inspection.User.user_name = this.localUser.user_name;
        this.tekshiruvlar[index].status == "complate";
      }
      this.tekshiruvlar[index].update = true;
      // if (type && (this.localUser.role == "Admin" || this.localUser.role == "Loborant")) {
      //   console.log(type)
      // }
    },
    textChangeValueIndex(key, index) {
      this.textChangeValue = {
        index: index,
        key: key
      };
    },
    Vazvrat(item, indT, index) {
      let x = "vazvrat";
      if (index >= 0) {
        if (item.vazvrat == true) {
          this.tekshiruvlar[indT].price -= item.price;
        } else {
          this.tekshiruvlar[indT].price += item.price;
        }
      }
      this.tekshiruvlar[indT].update = true;
      this.$emit("delTek", item.price, item.vazvrat, x.item);
    },
    getShablon() {
      let self = this;
      axios({
        method: "post",
        url: "/shablon_doctor/shablonOne",
        data: {
          doctor_id: self.localUser.id,
          doc_type: "reg_inspec"
        }
      }).then(res => {
        if (res) {
          self.itemsShablon = res.data.data;
        }
      });
    },
    Arrow(item) {
      let data = "";
      item.registration_inspection_child.forEach(el => {
        let name = el.name ? el.name : "-";
        let text = el.text ? el.text : "-";
        // if(el.name && el.text){
        data += " " + name + ":" + text + ",";
        // }
      });
      this.$store.state.ArrowData = {
        name: item.inspection.name,
        category: item.category.nqame,
        value: data
      };
      this.$bvToast.toast(this.$t("Малумотлар қўшилди"), {
        title: this.$t("Огоҳлантириш"),
        autoHideDelay: 2000,
        appendToast: true,
        variant: "success"
      });
    },
    RowClickedShab($events, indRegShif) {
      let text = JSON.parse(
        this.tekshiruvlar[
          indRegShif
        ].registration_inspection_child[0].norm.toString()
      );
      let shablonText = JSON.parse($events.text.toString());
      this.tekshiruvlar[indRegShif].update = true;
      this.tekshiruvlar[indRegShif].table_type = $events.table_type;
      // if ($events.table_type) {
      //   text = "";
      // } else {
        for (let index = 0; index < shablonText.length; index++) {
          const el = shablonText[index];
          if (text[index]) {
            text[index][`${text[index].key}`] = el[`${el.key}`];
          } else {
            text.push(el);
          }
        }
      // }
      this.tekshiruvlar[
        indRegShif
      ].registration_inspection_child[0].norm = JSON.stringify(text);
      // if(this.textChangeValue.index == null){
      //   text[0].value += $events.text
      //   this.tekshiruvlar[indRegShif].registration_inspection_child[0].norm += JSON.stringify(text)
      // } else {
      //   text[this.textChangeValue.index][`${this.textChangeValue.key}`] += $events.text
      //   this.tekshiruvlar[indRegShif].registration_inspection_child[0].norm += JSON.stringify(text)
      // }
      this.textChangeValue = {
        index: null,
        key: null
      };

      // `<h4>${$events.text}</h4>`;
      this.$bvModal.hide(
        `${"modal-shablon" + indRegShif + "reg_inspec" + this.modalIdCom}`
      );
    },
    PechatTek(item) {
      const indT = this.PechatTekshiruv.findIndex(el => el.id == item.id);
      if (indT == -1) {
        this.PechatTekshiruv.push(item);
      } else {
        this.PechatTekshiruv.splice(indT, 1);
      }
    },
    pechat(itemT, item) {
      let child = [];
      child.push(item);
      const indT = this.pechatTek.findIndex(el => el.id == itemT.id);
      if (indT == -1) {
        this.pechatTek.push({
          id: itemT.id,
          category: itemT.category,
          inspection: itemT.inspection,
          type: itemT.type,
          uzi: itemT.uzi,
          user_id: itemT.user_id,
          shablon: itemT.shablon,
          registration_inspection_child: child
        });
      } else {
        const indChild = this.pechatTek[
          indT
        ].registration_inspection_child.findIndex(el => el.id == item.id);

        if (indChild == -1) {
          this.pechatTek[indT].registration_inspection_child.push(item);
        } else {
          if (this.pechatTek[indT].registration_inspection_child.length == 1) {
            this.pechatTek.splice(indT, 1);
          } else {
            this.pechatTek[indT].registration_inspection_child.splice(
              indChild,
              1
            );
          }
        }
      }
    },
    allPechat(item) {
      let t = [];
      let x = [];
      if (this.pechatTek.length == 0) {
        x.push(item);
      } else {
        x = this.pechatTek;
      }
      let data = this.Tekshiruvchi.find(el => el.id == item.user_id);
      this.activeUser = data.user_name
      
      t = {
        bemorId: this.$store.state.bemor.id,
        name: this.$store.state.bemor.fullname,
        gender: this.$store.state.bemor.gender,
        birthday: this.$store.state.bemor.birthday,
        create_at: this.created_at,
        inspection: x,
        activeUser: this.activeUser
      };
      localStorage.setItem("Tekshiruvlar", JSON.stringify(t));
      // this.$router.push("/user");
      let pechatPath = "";
      if (!item.shablon) {
        pechatPath = "/user-tekshiruv";
      } else {
        pechatPath = "/user-tekshiruv-shablon";
      }
      const i = this.$router.resolve({
        path: pechatPath
      });
      window.open(i.href, "_blank");
      this.pechatTek = [];
    },
    Change(item, index) {
      this.$emit("delTek", item.price, false);
      this.$emit("SummaChange", this.price, true);
      this.tekshiruvlar[index].price = this.price;
      this.tekshiruvlar[index].backlog = this.price;
      this.tekshiruvlar[index].update = true;
      this.$bvModal.hide("modal-summa-change-tek" + index + this.modalIdCom);
    },
    changeCount(item, index){
      let count = Number(item.count)
      if(count > 0){
        this.$emit("delTek", item.price, false);
        this.$emit("SummaChange", item.default_price * count, true);
        this.tekshiruvlar[index].update = true;
        this.tekshiruvlar[index].price = item.default_price * count;
        this.tekshiruvlar[index].backlog = item.default_price * count - item.pay_summa;
      } else {
        return 0
      }
    },
    close(ind) {
      this.price = 0;
      this.$bvModal.hide("modal-summa-change-tek" + ind + this.modalIdCom);
    },
    
    uziComplate(item, indT) {
      this.tekshiruvlar[indT].status = "complate";
      this.tekshiruvlar[indT].update = true;
    }
  }
};
</script>
<style>
.ins-count{
  background: #eefd1f;
  border: 1px solid #f59032;
  height: 25px;
  width: 25px;
  font-weight: 500;
  text-align: center;
  /* color: #fff; */
  border-radius: 50%;
  position: absolute;
  top: -50px;
  left: -5px;
}
.vazvrat {
  background: #ff00004a !important;
}
.multiline-text {
  white-space: pre-line;
}
.tek-name-d {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background: rgba(7, 100, 172, 0.058);
  border-radius: 10px;
  padding: 7px;
  margin-bottom: 10px;
  border: 1px solid rgb(70, 112, 250);
}
.colorBacklog {
  background: rgba(6, 247, 66, 0.432);
}
.tek-nomi-s {
  font-size: 20px;
  font-weight: 600;
  display: flex;
  /* justify-content: center; */
  color: rgb(70, 112, 250);
}
.BayonotThead {
  background: #fff !important;
  color: black !important;
  text-align: center;
  border: 1px solid #a1a1a1 !important;
}
.BayonotThead td {
  border: 1px solid #a1a1a1 !important;
}
.Tekshiruvchi-index-user {
  width: 250px;
}
.Tekshiruvchi-index-user .vs__selected-options span:first-child {
  width: 90% !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.Tekshiruvchi-index-user .vs__selected-options {
  width: 90%;
}
.c-editor-edit .ql-editor p {
  /* font-size: 18px; */
  font-weight: 500;
}
.BayonotThead tr {
  padding: 0px;
}
.BayonotThead td {
  border: 1px solid #a1a1a1 !important;
  padding: 0px !important;
}
</style>
